import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemEmptyMug extends Item {
    /**
     * @param {string} id
     */
    constructor(id) {
        super(id, texture("prop_empty_slug_mug_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}